
import { useLanguage } from '@/hooks/useLanguage';
import { NavLink } from './NavLink';
import { ThemeToggle } from '../ThemeToggle';
import { LanguageToggle } from '../LanguageToggle';

interface DesktopNavProps {
  isRouteActive: (path: string) => boolean;
}

export function DesktopNav({ isRouteActive }: DesktopNavProps) {
  const { t } = useLanguage();

  return (
    <nav className="hidden md:flex items-center space-x-1">
      <NavLink to="/" isActive={isRouteActive('/') || isRouteActive('/dashboard')}>
        {t('navbar.dashboard')}
      </NavLink>
      <NavLink to="/news" isActive={isRouteActive('/news')}>
        {t('navbar.news')}
      </NavLink>
      <NavLink to="/leaks" isActive={isRouteActive('/leaks')}>
        {t('navbar.leaks')}
      </NavLink>
      <NavLink to="/CVE" isActive={isRouteActive('/CVE')}>
        {t('navbar.cve')}
      </NavLink>
      <NavLink to="/ransomware" isActive={isRouteActive('/ransomware')}>
        {t('navbar.ransomware')}
      </NavLink>
      <NavLink to="/eol" isActive={isRouteActive('/eol')}>
        {t('navbar.eol')}
      </NavLink>
      <NavLink to="/releases" isActive={isRouteActive('/releases')}>
        {t('navbar.releases')}
      </NavLink>
      <div className="ml-4 flex items-center space-x-3">
        <LanguageToggle />
        <ThemeToggle />
      </div>
    </nav>
  );
}
